import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';

import './SearchTypeDropdown.scss';

class SearchTypeDropdown extends React.PureComponent {
  getOptions() {
    const options = _.map(this.props.options, option => ({
      label: <FormattedMessage id={`Search.searchTypes.${option}`} />,
      value: option
    }));
    return options;
  }

  getSelected() {
    return <FormattedMessage id={`Search.searchTypes.${this.props.selected}`} />;
  }

  static getAriaLabel() {
    return <FormattedMessage id="searchTypeDropdownLabel" />;
  }

  render() {
    const { handleSelect, className } = this.props;

    return (
      <div className="cp-search-type-dropdown" data-test-id="searchType">
        <Dropdown
          dataKey="search-type-dropdown"
          selected={this.getSelected()}
          className={cn('btn dropdown-toggle btn-flat btn-default', className)}
          options={this.getOptions()}
          handleSelect={handleSelect}
          labelLocalizedText={SearchTypeDropdown.getAriaLabel()}
        />
      </div>
    );
  }
}

SearchTypeDropdown.propTypes = {
  selected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  handleSelect: PropTypes.func,
  className: PropTypes.string
};

export default SearchTypeDropdown;
